// extracted by mini-css-extract-plugin
export default {"previewWrapper":"preview-wrapper__previewWrapper--SxLyi","downloadButton":"preview-wrapper__downloadButton--i8XYF"};